import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function SchoolPhilosophy() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">School Philosophy</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> School Philosophy</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>School Philosophy</h1>
                        </div>
                        <div className="col-12 school-philosophy">
                            <ul>
                                <li>To impart value based education with a blend of new discoveries & technological tools.</li>
                                <li>To recognize and respect that every child is unique with lots of Creativities and Innovations in mind.</li>
                                <li>To engage children with experimental and personalized learning, fostering a sense of integrity, collaboration, trust and shared responsibility.</li>
                                <li>To provide children a Fun based environment where they Learn, Play and Grow.</li>
                                <li>To provide 360 degree quality services to all stakeholders like Parents, Teachers, Community and especially our little ones.</li>
                                <li>To help create an environment where every child enters the school with a huge smile and walks out with giggles and chuckles.</li>
                                <li>To create values, voice & vision right from childhood stage with quality inputs.</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default SchoolPhilosophy